export default "__VITE_ASSET__c05a6470__"